import { MenuMode } from '../../StylableHorizontalMenu.types';
import { parseValueFromCss } from './parseCss';

const LINE_HEIGHT_NORMAL = 1.14;

const getPaddingAndBorder = (
  cssText: string,
  selector: string,
  isVertical = true,
) => {
  const padding1Key = `padding-${isVertical ? 'top' : 'left'}`;
  const padding2Key = `padding-${isVertical ? 'bottom' : 'right'}`;

  const padding = parseValueFromCss(cssText, selector, 'padding', 0);
  const padding1 = parseValueFromCss(cssText, selector, padding1Key, padding);
  const padding2 = parseValueFromCss(cssText, selector, padding2Key, padding);

  const borderWidth = parseValueFromCss(cssText, selector, 'border', 0);

  return 2 * Number(borderWidth) + Number(padding1) + Number(padding2);
};

const getMinScrollHeight = (cssText: string) => {
  const rootInnerHeight = getPaddingAndBorder(cssText, '');
  const menuItemInnerHeight = getPaddingAndBorder(cssText, 'menuItem');

  const fontSize = parseValueFromCss(
    cssText,
    'menuItem::label',
    'font-size',
    0,
  );
  const textHeight = Math.round(Number(fontSize) * LINE_HEIGHT_NORMAL);

  return rootInnerHeight + menuItemInnerHeight + textHeight;
};

const getScrollButtonWidth = (cssText: string): number => {
  const iconWidth = parseValueFromCss(
    cssText,
    'scrollButton::icon',
    'width',
    0,
  );
  return (
    getPaddingAndBorder(cssText, 'scrollButton', false) + Number(iconWidth)
  );
};

// minimal limit for component resizing
export const getMinSize = (
  menuMode: MenuMode,
  cssText: string,
): { 'min-height'?: string; 'min-width': string } => {
  if (menuMode === 'scroll') {
    return {
      'min-height': `${getMinScrollHeight(cssText)}px`,
      'min-width': `${getScrollButtonWidth(cssText) * 2}px`,
    };
  }

  return {
    'min-width': 'min-content',
  };
};
